export default __webpack_public_path__ + "static/media/Timetracking-dashboard-thumbnail.47eb8ad2.png";